import { useMemo, useRef } from "react";
import { useToast as useToastContext } from "../context/Toast/ToastContext";

export const useToast = () => {
  const toast = useToastContext();
  const {
    addToast,
    error,
    info,
    removeAllToasts,
    removeToast,
    success,
    toasts,
    warning
  } = toast;
  const toastsRef = useRef(toasts);
  toastsRef.current = toasts;

  return useMemo(() => {
    const showToast = (message, type = "info", options = {}) => {
      const handler = { error, info, success, warning }[type];
      return (
        handler?.(message, options) || addToast(message, type, options)
      );
    };

    const api = {
      success,
      error,
      warning,
      info,
      showToast,
      removeToast,
      removeAllToasts
    };

    Object.defineProperty(api, "toasts", {
      enumerable: true,
      get: () => toastsRef.current
    });

    return api;
  }, [
    addToast,
    error,
    info,
    removeAllToasts,
    removeToast,
    success,
    warning
  ]);
};

export default useToast;
